<template>
  <div>
    <div class="modal-overlay" />
    <div class="modal-container  c-z-popup">
      <div class="close-btn">
        <button
          title="Fechar"
          @click="closeModal"
        >
          <c-icon name="close" />
        </button>
      </div>
      <div class="modal-body">
        <header>
          <h3 class="c-text-h3 c-text-primary-100 ui-mb-4">
            {{ productName }}
          </h3>
          <section class="flex justify-between ui-mt-6 ui-mb-2 ui-pr-4">
            <p class="c-text-b2">
              Itens que compõem esse produto ({{ horizontalAccesses.length }})
            </p>
          </section>
        </header>
        <main>
          <section>
            <div
              v-for="(item, index) in horizontalAccesses"
              :key="'nfe-setting-'+index"
              class="ui-flex ui-justify-between section-item ui-items-center"
            >
              <p
                :style="{
                  color: item.excluded_by_user ? 'var(--c-color-gray-300)' : '',
                }"
              >
                {{ item.name }}
              </p>
              <div class="item-info">
                <p v-if="item.excluded_by_user">
                  item removido
                </p>
              </div>
            </div>
          </section>
        </main>
        <footer class="ui-mt-8">
          <div>
            <p class="c-text-b2">
              Subtotal
            </p>
            <p class="c-text-h3 c-text-primary-100 subtotal-section">
              <span>{{ amountDisplay }}</span>
            </p>
          </div>
          <div class="button-container">
            <div>
              <c-button
                @click="closeModal"
                class="ok-button"
              >
                Ok
              </c-button>
            </div>
          </div>
        </footer>
      </div>
    </div>
  </div>
</template>
<script>
import { CButton, CIcon } from '@estrategiahq/coruja-web-ui';

export default {
  components: {
    CIcon,
    CButton,
  },
  name: 'ItemsDetails',
  props: {
    orderItem: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  computed: {
    horizontalAccesses () {
      const access = this.orderItem.horizontalsAccesses || [];
      return access.sort((a, b) => {
        return (a.excluded_by_user === true) - (b.excluded_by_user === true);
      });
    },
    productName () {
      return this.orderItem.description || '';
    },
    amountDisplay () {
      return this.convertToCurrency(this.orderItem.amountPaid || 0);
    },
  },
  methods: {
    closeModal () {
      this.$emit('close');
    },
    convertToCurrency (amount) {
      const format = { minimumFractionDigits: 2, style: 'currency', currency: 'BRL' };
      return amount === 0 ? 'Grátis' : (amount / 100).toLocaleString('pt-BR', format);
    },
  },
};
</script>
<style scoped lang="scss">
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
}
.modal-container {
  position: fixed;
  background-color: white;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  width: 70%;
  max-width: 700px;
  max-height: 80%;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 1.5rem;
  overflow: hidden;

  @media (max-width: 768px) {
      width: 100%;
  }

  .modal-body {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    overflow: hidden;
  }

  main {
    overflow-y: auto;
    flex-grow: 1;
  }
}
.close-btn {
  position: absolute;
  right: 0.2rem;
  top: 0.2rem;
}
.section-item {
  padding: 0.5rem;
  border-bottom: 1px solid var(--c-color-gray-200);
}
footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.subtotal-section {
  min-height: 2rem
}
.button-container {
  display: flex;
  justify-content: flex-end;
  gap: 1.5rem;

  button {
    min-width: 8.5rem;
  }
}
.ok-button {
  @media screen and (max-width: 768px) {
      display: none;
  }
}
.item-info {
  color: var(--c-color-gray-300);
  font-size: 0.8rem;
  font-weight: 400;
  text-align: right;
  font-style: italic;
}
</style>
